<script setup lang="ts">
import { onMounted } from 'vue';
import AppHeader from './components/AppHeader.vue';
import { useAuthStore } from './stores/auth';
import { useChatContextStore } from './stores/chatContext';
import { isInClient } from './lib/liff';

const auth = useAuthStore();
const chat = useChatContextStore();

onMounted(() => {
  // If we have a cached user, just refresh in the background; nothing blocks the first paint.
  // If not, the router guard already issued a fetchMe before allowing navigation.
  if (auth.user) auth.revalidate();
  // Only resolve LIFF context when running inside the LINE app; outside,
  // getContext() always returns null and the cached "personal" is correct.
  if (isInClient()) void chat.refresh();
});
</script>

<template>
  <div class="mx-auto flex min-h-screen max-w-2xl flex-col">
    <AppHeader />
    <main class="flex-1 px-4 py-4 pb-24">
      <RouterView />
    </main>
  </div>
</template>
